export const MonthBoxCellIdPrefix = 'mbc_'
